<template>
    <v-btn @click="onClick"
           content="Lutify.me LUTs"
		   v-tippy="{placement: 'right', boundary: 'window', onShow: () => onShowTooltip(), onHide: () => onHideTooltip()}"
           :disabled="isDisabled"
    >
        <v-icon class="material-symbols-outlined">deployed_code</v-icon>
    </v-btn>
</template>

<script>

import { mapState } from "vuex";
import CanMixin from "@/mixins/CanMixin";

export default {
    mixins: [CanMixin],

    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image']),
        isDisabled() {
            return !this.canUseColorGradingTools || this.blockLoading || !this.image || this.IDT.initial
        }
    },
    methods: {
        onClick() {
            this.$store.dispatch('UI/setLeftColumn', 'products')
        },
		onShowTooltip() {
			this.$nextTick(() => {
				this.$root.$refs.addControlButtonsContainer._tippy.hide();
			})
		},
		onHideTooltip() {
			this.$nextTick(() => {
				setTimeout(() => {
					if ($(this.$root.$refs.addControlButtonsContainer).find('[aria-describedBy]').length > 0) return;
					if (this.$root.$refs.addControlButtonsContainer.mouseOver) return

					UI.toggleStartTips()

				}, 500)
			})
		}
    },
};
</script>
